export function generateHashString(url: string): number {
  let hash = 5381;
  for (let i = 0; i < url.length; i++) {
    hash = (hash << 5) + hash + url.charCodeAt(i); // hash * 33 + char
  }
  return Math.abs(hash);
}
